// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paymentDetailContainer {
  padding: 20px;
  max-width: 500px;
}

.pageTitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.paymentInfoBox {
  background-color: #FFF5E9;
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 40px;
}

.paymentInfoItem {
  margin-bottom: 12px;
  font-size: 16px;
  color: #000;
  line-height: 1.5;
}

.paymentInfoItem:last-child {
  margin-bottom: 0;
}

.customerSupportSection {
  margin-top: 40px;
}

.sectionTitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.supportButtons {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.supportButton {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #EFF0FE;
  border: none;
  border-radius: 8px;
  padding: 15px 20px;
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  color: #333;
  transition: background-color 0.2s;
  width: 100%;
  max-width: 400px;
  position: relative;
}

.supportButton:hover {
  background-color: #E1E2F5;
}

.arrowIcon {
  font-size: 20px;
  color: #00C853;
  position: absolute;
  right: 20px;
}

/* 로딩, 에러, 빈 상태 메시지 스타일 */
.loadingMessage,
.errorMessage,
.emptyMessage {
  text-align: center;
  padding: 30px;
  font-size: 16px;
  color: #666;
  background-color: #f5f5f5;
  border-radius: 8px;
  margin-top: 20px;
}

.errorMessage {
  color: #e53935;
  background-color: #ffebee;
}

.emptyMessage {
  color: #0d47a1;
  background-color: #e3f2fd;
}

.retryButton {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.retryButton:hover {
  background-color: #e0e0e0;
}`, "",{"version":3,"sources":["webpack://./src/styles/PaymentDetail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA,yBAAyB;AACzB;;;EAGE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".paymentDetailContainer {\n  padding: 20px;\n  max-width: 500px;\n}\n\n.pageTitle {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 30px;\n}\n\n.paymentInfoBox {\n  background-color: #FFF5E9;\n  border-radius: 8px;\n  padding: 25px;\n  margin-bottom: 40px;\n}\n\n.paymentInfoItem {\n  margin-bottom: 12px;\n  font-size: 16px;\n  color: #000;\n  line-height: 1.5;\n}\n\n.paymentInfoItem:last-child {\n  margin-bottom: 0;\n}\n\n.customerSupportSection {\n  margin-top: 40px;\n}\n\n.sectionTitle {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.supportButtons {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.supportButton {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #EFF0FE;\n  border: none;\n  border-radius: 8px;\n  padding: 15px 20px;\n  cursor: pointer;\n  text-align: left;\n  font-size: 16px;\n  color: #333;\n  transition: background-color 0.2s;\n  width: 100%;\n  max-width: 400px;\n  position: relative;\n}\n\n.supportButton:hover {\n  background-color: #E1E2F5;\n}\n\n.arrowIcon {\n  font-size: 20px;\n  color: #00C853;\n  position: absolute;\n  right: 20px;\n}\n\n/* 로딩, 에러, 빈 상태 메시지 스타일 */\n.loadingMessage,\n.errorMessage,\n.emptyMessage {\n  text-align: center;\n  padding: 30px;\n  font-size: 16px;\n  color: #666;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  margin-top: 20px;\n}\n\n.errorMessage {\n  color: #e53935;\n  background-color: #ffebee;\n}\n\n.emptyMessage {\n  color: #0d47a1;\n  background-color: #e3f2fd;\n}\n\n.retryButton {\n  display: block;\n  margin: 20px auto;\n  padding: 10px 20px;\n  background-color: #f0f0f0;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.retryButton:hover {\n  background-color: #e0e0e0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
